module.exports = __webpack_public_path__ + "static/media/Pouzite_literarni_zdroje.ca72e0a2.md";